import { createStyles, makeStyles } from '@material-ui/styles';
import {
  Grid,
  Theme,
  Typography,
} from '@material-ui/core';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import { Error, PagesTitle, Space, Button } from '../../../components';
import { selectPasswordRecoveryForm, selectResend } from '../../../store/modules/password-recovery/selectors';
import { EnvelopeIcon } from '../../../components/icon/solid';
import { resendPasswordRecoveryRequest } from '../../../store/modules/password-recovery/actions';
import { useTitle } from '../../../hooks';
import PageContainer from '../PageContainer';

const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    height: '64px',
    width: '64px',
    color: palette.menuAction.selected,
  },
  title: {
    marginTop: '56px',
    marginBottom: '24px',
  },
  body: {
    color: palette.text.secondary,
    textAlign: 'center',
    fontSize: '16px',
  },
  subtitle: {
    color: palette.text.secondary,
    fontSize: '16px',
    marginTop: '16px',
    textAlign: 'center',
  },
  subtitleLink: {
    color: palette.link.color,
    fontWeight: 600,
    textTransform: 'none',
  },
}), { name: 'PasswordRecovery' });

const EmailSent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useTitle('Email Sent');

  const { loading, error } = useSelector(selectResend);

  const { email } = useSelector(selectPasswordRecoveryForm);
  useEffect(() => {
    if (!email) {
      dispatch(push('/'));
    }
  }, [dispatch, email]);

  const resend = useCallback(() => {
    dispatch(resendPasswordRecoveryRequest(email));
  }, [dispatch, email]);

  return (
    <PageContainer>
      <Grid container className={classes.root}>
        <EnvelopeIcon className={classes.icon} />
        <PagesTitle className={classes.title}>Password reset email sent!</PagesTitle>
        <Typography variant="body1" className={classes.body}>
          An email has been sent to:
        </Typography>
        <Typography variant="h6" >
          {email}
        </Typography>
        <Typography variant="subtitle1" className={classes.subtitle}>
          Please check your email to reset your password.
        </Typography>
        <Typography variant="subtitle1" className={classes.subtitle}>
            Didn&apos;t get an email?
          <Space />
          <Button
            className={classes.subtitleLink}
            onClick={resend}
            disableRipple
            disabled={loading}
          >
              Try again.
          </Button>
        </Typography>
        <Error>{error}</Error>
      </Grid>
    </PageContainer>
  );
};

export default EmailSent;
